export function handleApiError(
  error,
  fallbackMessage = "خطای نامشخصی رخ داده است"
) {
  const data = error?.response?.data;
console.log("Data",data);

  // اولویت اول: نمایش errors به صورت لیست تیک‌دار
  if (data?.errors && Array.isArray(data.errors) && data.errors.length > 0) {
    return data.errors.map((err) => `• ${err}`).join("\n");
  }

  // اولویت دوم: نمایش message
  if (data?.message) {
    return data.message;
  }

  // اولویت سوم: نمایش error.message (برای خطاهای دیگه)
  if (error?.message) {
    return error.message;
  }

  // آخرین گزینه: fallback
  return fallbackMessage;
}

/**
 * هر چیزی که سرور در message گذاشته را برمی‌گرداند.
 * اگر message نبود، خطای ساده می‌دهد.
 * ورودی می‌تواند خطای axios (با err.response) یا خودِ body پاسخ باشد.
 */
export function handleApiErrorTamin(err) {
  // اگر خطای axios باشد => err.response.data
  // اگر خود body باشد => مستقیم err
  const body = err.response ? err.response.data : err;

  // اولویت: message سرور
  if (body && body.message) return body.message;

  // اگر message نبود ولی errors پر بود
  if (body && Array.isArray(body.errors) && body.errors.length) {
    return body.errors[0];
  }

  // واقعاً چیزی نبود
  return "خطای نامشخص";
}
